import React from "react";
import { useEffect, useState } from "react";
import DOMPurify from 'dompurify';
import { getInfoHubHtml } from "../../../utility/common.js";
import { Helmet } from "react-helmet";
import './RegisterBanner.scss';

const RegisterBanner = ({courseType, courseId = "",topic}) =>{
    const [htmlData, setHtmlData] = useState(null);
    let lng = localStorage.getItem('lng') ? localStorage.getItem('lng') : 'en';
    let aemConfigData = localStorage.getItem('aemConfigData') ? JSON.parse(localStorage.getItem('aemConfigData')) : null;
    let updatedCiamSignInURL = null;
    useEffect(() => {
   // Construct the AEM URL dynamically based on courseType or topic
   let aemURL = "";
   if (topic) {
     aemURL = `${global.config.AEM_API_BASE_PATH}/content/experience-fragments/vsbdr/${global.config.aemUrlEnv}/${lng}/Register-Banner/result/master.html`;
   } else if (courseType === "quickTip") {
     aemURL = `${global.config.AEM_API_BASE_PATH}/content/experience-fragments/vsbdr/${global.config.aemUrlEnv}/${lng}/Register-Banner/quicktips/master.html`;
   } else if (courseType === "learningPath") {
     aemURL = `${global.config.AEM_API_BASE_PATH}/content/experience-fragments/vsbdr/${global.config.aemUrlEnv}/${lng}/Register-Banner/learning-path/master.html`;
   } else if (courseType === "course") {
     aemURL = `${global.config.AEM_API_BASE_PATH}/content/experience-fragments/vsbdr/${global.config.aemUrlEnv}/${lng}/category/register-banner/master.html`;
    //const aemURL = `http://localhost:4502/content/experience-fragments/vsbdr/QA1/en/category/register-banner/master.html`;
   } else if (courseType === "event") {
     aemURL = `${global.config.AEM_API_BASE_PATH}/content/experience-fragments/vsbdr/${global.config.aemUrlEnv}/${lng}/category/register-banner/master.html`;
   } else if (courseType === "inpersonevents") {
    aemURL = `${global.config.AEM_API_BASE_PATH}/content/experience-fragments/vsbdr/${global.config.aemUrlEnv}/${lng}/Register-Banner/inpersonevents/master.html`;
  }

        getInfoHubHtml(aemURL)
          .then((response) => {
            setHtmlData(response?.data)
          });
      }, [lng]);

    useEffect(() =>{
        if (!htmlData) return;
    
        const existingSticky = document?.querySelector('script[src*= "stickybanner.js"]');
        let script;
        let courseSection = document?.querySelectorAll('.course-banner') ?? null;
        let eventSection = document?.querySelectorAll('.event-banner') ?? null; 
        if(!existingSticky){
          script = document.createElement('script');
          script.src = `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}${global.config.aemUrlEnv === "QA1" ? '/QA1' :global.config.aemUrlEnv === "QA2" ? '/QA2' : ''}${aemConfigData?.minifiedPath || ''}/js/stickybanner${aemConfigData?.minifiedExt || ''}.js`;
          script.type = 'text/javascript';
          script.async = false;
          document.body.appendChild(script);

        }

        if(courseType){
        if(courseType == 'course'){
          if(eventSection && courseSection) 
            {
              eventSection.forEach((event) =>{
                event.classList.add('hide')
              }); 
              courseSection.forEach((course) => {
                course.classList.remove('hide');
              }); 
            }
          }
          else if(courseType == 'event'){
          if(eventSection && courseSection) 
            {
            eventSection.forEach((event) =>{
              event.classList.remove('hide')
            }); 
            courseSection.forEach((course) => {
              course.classList.add('hide');
            });
          }
        }
      }
      
      if(courseId !== ''){
        let userLanguage = localStorage.getItem('lng') ?? 'en';
        if (window?.location?.search?.includes('utm_')) {
          const utmUrl = `${window?.location?.search?.substring(1)}`;
          localStorage.setItem('utmUrl', utmUrl);
          updatedCiamSignInURL = `${global.config.CIAM_SIGN_IN_URL}?goto=${process.env.REACT_APP_AUTHENTICATED_URL_BASE_PATH}${userLanguage === 'es' ? 'es/' : null}course-details/${courseId}?ciamLang=${userLanguage}&${utmUrl}`;
        } else {
          if (localStorage.getItem('utmUrl')) {
            updatedCiamSignInURL = `${global.config.CIAM_SIGN_IN_URL}?goto=${process.env.REACT_APP_AUTHENTICATED_URL_BASE_PATH}${userLanguage === 'es' ? 'es/' : null}course-details/${courseId}?ciamLang=${userLanguage}&${localStorage.getItem('utmUrl')}`;
          } else {
            updatedCiamSignInURL = `${global.config.CIAM_SIGN_IN_URL}?goto=${process.env.REACT_APP_AUTHENTICATED_URL_BASE_PATH}${userLanguage === 'es' ? 'es/' : null}course-details/${courseId}?ciamLang=${userLanguage}`;
          }
        }
        // const mainRegisterBar = document.querySelector('section#mainRegisterBar:not(.hide)') ?? null;
        // const bottomFixedRegisterBar = document.querySelector('section#bottomFixedRegisterBar:not(.hide)') ?? null;
        // const mainSignInLink = mainRegisterBar?.querySelector('a.text-link.ml-4X');
        // const bottomSignInLink = bottomFixedRegisterBar?.querySelector('a.text-link.ml-4X');
        
        if(!location.href.includes('dashboard') && mainSignInLink && bottomSignInLink){
          mainSignInLink.href = updatedCiamSignInURL;
          bottomSignInLink.href = updatedCiamSignInURL;
        }
      } else if (window.location.pathname.includes('results')) {
        let userLanguage = localStorage.getItem('lng') ?? 'en';
        const topic = window.location.pathname.split('/').pop(); // Extract the topic from the URL
      
        if (window?.location?.search?.includes('utm_')) {
          const utmUrl = `${window?.location?.search?.substring(1)}`;
          localStorage.setItem('utmUrl', utmUrl);
          updatedCiamSignInURL = `${global.config.CIAM_SIGN_IN_URL}${process.env.REACT_APP_AUTHENTICATED_URL_BASE_PATH}results/${topic}?ciamLang=${userLanguage}&${utmUrl}`;
        } else {
          if (localStorage.getItem('utmUrl')) {
            updatedCiamSignInURL = `${global.config.CIAM_SIGN_IN_URL}${process.env.REACT_APP_AUTHENTICATED_URL_BASE_PATH}results/${topic}?ciamLang=${userLanguage}&${localStorage.getItem('utmUrl')}`;
          } else {
            updatedCiamSignInURL = `${global.config.CIAM_SIGN_IN_URL}${process.env.REACT_APP_AUTHENTICATED_URL_BASE_PATH}results/${topic}?ciamLang=${userLanguage}`;
          }
        } 
        const mainRegisterBar = document.querySelector('section#mainRegisterBar:not(.hide)') ?? null;
        const bottomFixedRegisterBar = document.querySelector('section#bottomFixedRegisterBar:not(.hide)') ?? null;
        const mainSignInLink = mainRegisterBar?.querySelector('a.text-link.ml-4X');
        const bottomSignInLink = bottomFixedRegisterBar?.querySelector('a.text-link.ml-4X');
      
        if (!location.href.includes('dashboard') && mainSignInLink && bottomSignInLink) {
          mainSignInLink.href = updatedCiamSignInURL;
          bottomSignInLink.href = updatedCiamSignInURL;
        }
      }
    
        return () =>{
          if(script){
            document.body.removeChild(script);
          }
          eventSection.forEach((event) =>{
              event.classList.remove('hide')
            }); 
          courseSection.forEach((course) => {
              course.classList.remove('hide');
            }); 
          localStorage.removeItem('utm_');
        };
      }, [htmlData]);

      return (
        <>
          <Helmet>
          <link
                  href={`${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}${global.config.aemUrlEnv === "QA1" ? '/QA1' : global.config.aemUrlEnv === "QA2" ? '/QA2' : ''}${aemConfigData?.minifiedPath || ''}/css/stickybanner${aemConfigData?.minifiedExt || ''}.css`}
                  rel='stylesheet'
                  type='text/css'
                ></link>
            </Helmet>
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(htmlData) }} />
        </>
      );
};

export default RegisterBanner;